import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export const Navigation = ({ lang, setLang, activeSection }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isHomePage = 
    location.pathname === "/" || 
    location.pathname === `/${lang}` || 
    location.pathname === `/${lang}/`;
  
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const flags = {
    tr: { src: "https://flagcdn.com/w40/tr.png", alt: "Türkçe", label: "TR" },
    en: { src: "https://flagcdn.com/w40/gb.png", alt: "English", label: "EN" },
    ru: { src: "https://flagcdn.com/w40/ru.png", alt: "Русский", label: "RU" }
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsLangMenuOpen(false);
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    closeMobileMenu(); 

    if (isHomePage) {
      const target = document.getElementById(targetId);
      if (target) {
        const headerOffset = 40; 
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    } else {
      navigate(`/${lang}/#${targetId}`);
    }
  };

  const handleLogoClick = (e) => {
    closeMobileMenu(); 
    if (isHomePage) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    } else {
      window.scrollTo(0, 0);
    }
  };

  const handleLangChange = (selectedLang) => {
    setLang(selectedLang);
    closeMobileMenu(); 
  };

  const formatNavText = (textTr, textRu, textEn) => {
    if (lang === "tr") {
      return textTr.toLocaleUpperCase("tr-TR");
    } else if (lang === "ru") {
      return textRu.toLocaleUpperCase("ru-RU"); 
    } else {
      return textEn.toUpperCase();
    }
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <style>
        {`
          #menu ul.nav li a {
            text-transform: none !important; 
          }

          #menu.navbar-default {
            background-color: #171717 !important; 
            border-color: transparent !important;
          }
          
          #menu.navbar-default .navbar-nav > li > a {
            color: #EDEDED !important; 
          }
          
          #menu.navbar-default .navbar-nav > li > a:hover,
          #menu.navbar-default .navbar-nav > li.active > a {
            color: #e5882a !important; 
          }

          #menu.navbar-default .navbar-toggle {
            border-color: #e5882a !important;
            z-index: 1001; /* Her şeyin üstünde kalmalı */
          }
          #menu.navbar-default .navbar-toggle .icon-bar {
            background-color: #e5882a !important;
          }

          .lang-dropdown-list {
            position: absolute;
            top: 100%;
            left: 15px;
            background-color: #171717; 
            border: 1px solid #333;
            list-style: none;
            padding: 8px 0;
            margin: 0;
            box-shadow: 0 4px 12px rgba(0,0,0,0.5);
            border-radius: 4px;
            min-width: 110px;
            z-index: 1000;
          }
          
          @media (min-width: 768px) {
            .lang-flag-btn {
               margin-top: 18px !important;
               padding: 0 !important;
            }
            .mobile-menu-wrapper {
               display: none; /* Mobilde değilse özel kapsayıcıyı sakla */
            }
          }

          /* ================================================================= */
          /* YENİ: MOBİL MENÜ İÇİN ÖZEL ÇÖZÜM                                  */
          /* ================================================================= */
          @media (max-width: 767px) {
            .navbar-collapse {
              display: none !important; /* Bootstrap'in bozuk menüsünü tamamen iptal ediyoruz */
            }
            
            .mobile-menu-wrapper {
              position: absolute;
              top: 80px; /* Navbar'ın tam altından başlar */
              left: 0;
              width: 100%;
              background-color: rgba(23, 23, 23, 0.98);
              backdrop-filter: blur(10px); /* Arka planı hafif bulanıklaştırır */
              border-top: 1px solid #e5882a;
              box-shadow: 0 10px 25px rgba(0,0,0,0.5);
              padding: 15px 0 25px 0;
              display: flex;
              flex-direction: column;
              align-items: center;
              z-index: 999;
              /* Animasyon için */
              opacity: ${isMobileMenuOpen ? "1" : "0"};
              visibility: ${isMobileMenuOpen ? "visible" : "hidden"};
              transform: ${isMobileMenuOpen ? "translateY(0)" : "translateY(-20px)"};
              transition: all 0.3s ease-in-out;
            }

            .mobile-menu-wrapper a {
              color: #EDEDED;
              font-family: 'Inter', sans-serif;
              font-size: 16px;
              font-weight: 600;
              text-decoration: none;
              padding: 12px 20px;
              width: 100%;
              text-align: center;
              border-bottom: 1px solid rgba(255,255,255,0.05);
            }
            
            .mobile-menu-wrapper a:hover,
            .mobile-menu-wrapper a.active-mobile {
              color: #e5882a;
              background-color: rgba(229, 136, 42, 0.1);
            }

            /* Dil Seçeneği Mobil Konumu */
            .mobile-lang-container {
              margin-top: 15px;
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;
            }

            .lang-dropdown-list {
              position: static; 
              margin-top: 10px;
              margin-bottom: 5px;
              background-color: transparent;
              border: none;
              box-shadow: none;
            }
          }
        `}
      </style>

      <div className="container">
        
        <div className="navbar-header">
          {/* Mobil Menü Tetikleyicisi */}
          <button
            type="button"
            className="navbar-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span className="sr-only">Menüyü Aç/Kapat</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          
          <Link className="navbar-brand" to={`/${lang}`} onClick={handleLogoClick}>
            <img 
              src="/img/omemtechbeyaz.png" 
              alt="Omemtech Logo" 
              className="navbar-logo" 
              fetchPriority="high" 
            />
          </Link>
        </div>

        {/* 1. MASAÜSTÜ MENÜSÜ (Mobilde gizlenir) */}
        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            <li className={activeSection === "about" ? "active" : ""}>
              <a href="#about" onClick={(e) => handleNavClick(e, "about")} className="page-scroll">
                {formatNavText("Hakkımızda", "О нас", "About Us")}
              </a>
            </li>
            
            <li className={activeSection === "portfolio" ? "active" : ""}>
              <a href="#portfolio" onClick={(e) => handleNavClick(e, "portfolio")} className="page-scroll">
                {formatNavText("Ürünlerimiz", "Продукция", "Products")}
              </a>
            </li>
            
            <li className={activeSection === "contact" ? "active" : ""}>
              <a href="#contact" onClick={(e) => handleNavClick(e, "contact")} className="page-scroll">
                {formatNavText("İletişim", "Контакты", "Contact")}
              </a>
            </li>

            <li style={{ position: 'relative', paddingLeft: '15px' }} onMouseLeave={() => setIsLangMenuOpen(false)}>
              <button 
                className="lang-flag-btn" 
                onClick={() => setIsLangMenuOpen(!isLangMenuOpen)}
                style={{ background: 'transparent', border: 'none', outline: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
              >
                <img src={flags[lang]?.src || flags.tr.src} width="26" alt={flags[lang]?.alt} style={{ borderRadius: '3px', boxShadow: '0 2px 5px rgba(0,0,0,0.3)' }} />
                <span style={{ fontSize: '12px', color: '#e5882a' }}>▼</span>
              </button>

              {isLangMenuOpen && (
                <ul className="lang-dropdown-list">
                  {Object.keys(flags).map((code) => (
                    <li key={code}>
                      <button
                        onClick={() => handleLangChange(code)}
                        style={{ display: 'flex', alignItems: 'center', width: '100%', padding: '8px 15px', background: lang === code ? '#222' : 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left', gap: '10px' }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#333'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = lang === code ? '#222' : 'transparent'}
                      >
                        <img src={flags[code].src} width="22" alt={flags[code].alt} style={{ borderRadius: '2px', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
                        <span style={{ color: '#EDEDED', fontSize: '14px', fontWeight: lang === code ? 'bold' : 'normal' }}>{flags[code].label}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          </ul>
        </div>

        {/* 2. MOBİL MENÜ (Masaüstünde gizlenir, sadece mobilde buton basılınca şıkça iner) */}
        <div className="mobile-menu-wrapper">
          <a href="#about" className={activeSection === "about" ? "active-mobile" : ""} onClick={(e) => handleNavClick(e, "about")}>
            {formatNavText("Hakkımızda", "О нас", "About Us")}
          </a>
          <a href="#portfolio" className={activeSection === "portfolio" ? "active-mobile" : ""} onClick={(e) => handleNavClick(e, "portfolio")}>
            {formatNavText("Ürünlerimiz", "Продукция", "Products")}
          </a>
          <a href="#contact" className={activeSection === "contact" ? "active-mobile" : ""} onClick={(e) => handleNavClick(e, "contact")}>
            {formatNavText("İletişim", "Контакты", "Contact")}
          </a>
          
          <div className="mobile-lang-container">
            <button 
              className="lang-flag-btn" 
              onClick={() => setIsLangMenuOpen(!isLangMenuOpen)}
              style={{ background: 'transparent', border: 'none', outline: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <img src={flags[lang]?.src || flags.tr.src} width="28" alt={flags[lang]?.alt} style={{ borderRadius: '4px' }} />
              <span style={{ color: '#EDEDED', fontSize: '16px', fontWeight: 'bold' }}>{flags[lang]?.label}</span>
              <span style={{ fontSize: '12px', color: '#e5882a' }}>▼</span>
            </button>

            {isLangMenuOpen && (
              <ul className="lang-dropdown-list">
                {Object.keys(flags).map((code) => (
                  <li key={code} style={{ width: '100%', textAlign: 'center' }}>
                    <button
                      onClick={() => handleLangChange(code)}
                      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '10px 20px', background: 'transparent', border: 'none', gap: '10px' }}
                    >
                      <img src={flags[code].src} width="24" alt={flags[code].alt} style={{ borderRadius: '2px' }} />
                      <span style={{ color: lang === code ? '#e5882a' : '#aaa', fontSize: '15px', fontWeight: lang === code ? 'bold' : 'normal' }}>
                        {flags[code].label}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

      </div>
    </nav>
  );
};